var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleClose = function SvgCircleClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.744 6.223l.636-.845a.994.994 0 0 1 1.4-.16.994.994 0 0 1 .16 1.4l-1 1.38 1 1.38a.994.994 0 0 1-.16 1.4.994.994 0 0 1-1.4-.16l-.636-.846-.636.846a.994.994 0 0 1-1.4.16.994.994 0 0 1-.16-1.4l1-1.38-1-1.38a.994.994 0 0 1 .16-1.4.994.994 0 0 1 1.4.16l.636.845zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14z"
  })));
};
export default SvgCircleClose;